import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/pasaporte.css'; // Pasaporte FIXARR: los tokens de la marca, antes que el resto
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
